import React, { useState } from "react";
import axios from "axios";
import { useFormikContext, getIn } from "formik";
import { useDispatch } from "react-redux";
import { Icons } from "assets/icons";
import { showAlert } from "store/slices/alertSlice";
import { Spinner } from "react-bootstrap";

const AITranslateButton = ({ sourceField, targetField, translateTo }) => {
  const dispatch = useDispatch();
  const { values, setFieldValue } = useFormikContext();
  const [loading, setLoading] = useState(false);
  const { translate } = Icons || {};

  // Use getIn to handle nested field paths like "title.en" or "description.ar"
  const sourceText = getIn(values, sourceField);

  const direction = translateTo === "ar" ? "en|ar" : "ar|en";

  const handleTranslate = async () => {
    if (!sourceText) {
      dispatch(
        showAlert({
          text:
            translateTo === "en" ? "Enter English text" : "Enter Arabic text",
          type: "error",
        })
      );
      return;
    }

    try {
      setLoading(true);

      const res = await axios.get(
        `https://applligentdemo.com/translation/index.php?q=${encodeURIComponent(
          sourceText
        )}&langpair=${direction}`
      );

      const translated = res?.data?.data?.translatedText || "";

      // setFieldValue handles nested paths automatically
      setFieldValue(targetField, translated);
    } catch (err) {
      dispatch(showAlert({ text: "Translation failed", type: "error" }));
    } finally {
      setLoading(false);
    }
  };

  if (sourceText?.length > 450) return null;

  return (
    <button
      type="button"
      className={`transparent_btn ai_translate_btn ${translateTo || ""}`}
      onClick={handleTranslate}
      disabled={!sourceText || loading}
    >
      {loading ? (
        <div className="loading_wrapper">
          <Spinner animation="border" variant="primary" />
        </div>
      ) : (
        <img src={translate} alt="translate" width={22} height={22} />
      )}
    </button>
  );
};

export default AITranslateButton;